module.exports = __webpack_public_path__ + "media/src/assets/images/comment-manager2-688a2349dea5aefcf81361df2b063821.png";